module.exports = __webpack_public_path__ + "static/media/Logo.cea7fd19.svg";